export default {
    headerCreate: 'เพิ่มวันหยุด',
    headerEdit: 'แก้ไขวันหยุด',
    holidayName: 'ชื่อวันหยุด',
    enterHolidayName: 'กรุณากรอกชื่อวันหยุด',
    holiday: 'วันหยุด',
    save: 'บันทึก',
    require: 'กรุณากรอกข้อมูล',
    congratulation: 'ยินดีด้วย',
    created: 'วันหยุดถูกสร้างแล้ว',
    updated: 'วันหยุดถูกแก้ไขแล้ว',
    errorTitle: 'เกิดข้อผิดพลาด'
}
